var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.571 0A.571.571 0 0 0 0 .571v2.621c0 .152.06.297.167.404l4 4a.571.571 0 0 0 .808 0l2.621-2.62a.571.571 0 0 0 0-.809l-4-4A.571.571 0 0 0 3.192 0H.572Zm2.286 2a.857.857 0 1 1-1.714 0 .857.857 0 0 1 1.714 0Z",
  fill: "#5D5D5D"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h10v10H0z"
})))));
export default SvgTag;